import { Socket } from '@medicusunion/front-utils';
import config from 'config';
import { USER_ID } from 'constants/voip';

import { instance } from 'utils/api';

const socket = new Socket({
  instance,
  userId: USER_ID,
  url: config.socket_url as string
});

export default socket;
